import api from "@/apisTuk";
import { debounce } from "../functions.js";
import {
  vuexLineOAuth,
  //   imgbb,
  imgAWS,
  reverseGeocode,
  onemapAddress,
  tukPhotos,
  graphhopperRoute,
  ipAddress,
  ipLookup,
} from "../apis.js";
import base64url from "base64url"; // lib to decode OAuth response
// import { stat } from "fs";
import { reject } from "core-js/fn/promise";

import geohash from "ngeohash";

export default {
  uploadImageAWS(_, data) {
    return new Promise((resolve, reject) => {
      imgAWS(data) // data contains 4 things: name, content, businessID, imageType
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // uploadImageOld({ commit }, imageFile) {
  //     return new Promise((resolve, reject) => {
  //         imgbb(imageFile)
  //             .then(res => resolve(res))
  //             .catch(err =>  reject(err))
  //     })
  // }, // deprecated imgbb for AWS, was blocked
  tukPhotos(_, businessID) {
    return new Promise((resolve, reject) => {
      tukPhotos(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getIPAddress({ commit }) {
    return new Promise((resolve, reject) => {
      ipAddress()
        .then((res) => {
          ipLookup(res.data.ip)
            .then((res2) => {
              commit("setIPAddress", res2.data);
              resolve(res2);
            })
            .catch((err) => reject(err));
        })
        .catch((err) => reject(err));
    });
  },
  onemapAddress({ commit }, postcode) {
    return new Promise((resolve, reject) => {
      onemapAddress(postcode)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // 8 Jul 2022: added google route fallback if graphhopper returns err
  // 7 Sep 2022: use_google flag to force google routes for problem addresses
  drivingRoute({ commit, state }, data) {
    var p = data.pickup;
    var pHash = geohash.encode(p.lat, p.lon);
    var d = data.dropoff;
    var dHash = geohash.encode(d.lat, d.lon);
    var obj = {
      pickup: pHash,
      dropoff: dHash,
      //  encoded: encoded,
      //  distance: Math.round(meters),
    };
    return new Promise((resolve, reject) => {
      // check if already exists
      var polyline = state.polylines.find(
        (l) => l.pickup === pHash && l.dropoff === dHash
      );
      if (polyline) {
        console.log("polyline EXISTS", polyline);
        resolve(polyline);
      } else {
        graphhopperRoute(data.pickup, data.dropoff)
          .then((res) => {
            console.log("graphhopperRoute", res.data);
            // if (!res.data.paths) reject(res);
            // if (!res.data.paths.length) reject(res);
            if (!res.data.paths || !res.data.paths.length) {
              throw new Error(
                "graphhopperRoute didn't return a result, try google"
              );
            }
            obj.source = "graphhopper";
            obj.encoded = res.data.paths[0].points;
            obj.distance = Math.round(res.data.paths[0].distance);
            commit("addPolyline", obj); // add new polyline
            resolve(obj);
          })
          .catch(() => {
            //  dispatch("drivingRouteGoogle", data); // return?
            // reject(err);
            api
              .directionsGet(data.pickup, data.dropoff)
              .then((res) => {
                console.log("googleMapsRoute", res.data);
                if (!res.data) reject(res);
                obj.source = "google"; // should read from res.data.source
                obj.encoded = res.data.encoded_polyline;
                obj.distance = res.data.distance; // already int meters
                commit("addPolyline", obj); // add new polyline
                resolve(obj);
              })
              .catch((err) => {
                console.log("ERR googleMapsRoute", err);
                reject(err);
              }); // timeout after 500ms
          });
      }
    });
  },
  drivingRouteGoogle({ commit }, data) {
    var p = data.pickup;
    var pHash = geohash.encode(p.lat, p.lon);
    var d = data.dropoff;
    var dHash = geohash.encode(d.lat, d.lon);
    return new Promise((resolve, reject) => {
      api
        .directionsGet(data.pickup, data.dropoff)
        .then((res) => {
          console.log("googleMapsRoute", res.data);
          if (!res.data) reject(res);
          var encoded = res.data.encoded_polyline;
          var meters = res.data.distance;
          var obj = {
            pickup: pHash,
            dropoff: dHash,
            encoded: encoded,
            distance: Math.round(meters),
          };
          // commit("addPolyline", obj); // add new polyline
          resolve(obj);
        })
        .catch((err) => {
          console.log("ERR googleMapsRoute", err);
          reject(err);
        }); // timeout after 500ms
    });
  },
  reverseGeocode(_, coords) {
    var lat = coords.lat;
    var lon = coords.lng;
    if (!lon) lon = coords.lon; // handle cases where lon is used instead of lng
    return new Promise((resolve, reject) => {
      reverseGeocode(lat, lon) //coords.lat, coords.lng)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  login({ commit }, lineUserID) {
    // LINE user login
    return new Promise((resolve, reject) => {
      api
        .vuexUsersGet(lineUserID)
        .then((res) => {
          console.log("API login", res.data);
          commit("setUser", res.data);
          commit("loginMethod", "line");
          resolve();
        })
        .catch((err) => {
          console.error("API login", err);
          reject(err);
        });
    });
  },
  getTranslationsByParent({ commit }, parentID) {
    return new Promise((resolve, reject) => {
      api
        .blobsGetTranslationsByParent(parentID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBlobsForList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .blobsGetList(payload.page, payload.region)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBlobsForWorkflow({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .blobsGetWorkflow(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDigitalMenuBlob(_, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .blobsGetDigitalMenu(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  saveBlob({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .blobsPost(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteBlob({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .blobsDelete(id)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // called when user profile page is mounted, to get latest user obj
  updateUser({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (!state.user) reject("not logged in");
      api
        .usersGetNew(state.user.id)
        .then((res) => {
          commit("updateUser", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getUserInfo(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .usersGetInfo(userID) // add uuid to login (this is used by fb login)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getUser({ commit, getters }, payload) {
    // console.log("DISPATCH getUser", payload);
    return new Promise((resolve, reject) => {
      api
        .usersGet(payload.source, payload.id, getters.getUUID) // add uuid to login (this is used by fb login)
        .then((res) => {
          console.log("API usersGet", res.data);
          if (typeof res.data === "object") {
            // API returns object if there was a user
            // else returns string saying you need to create new
            commit("setUser", res.data);
            commit("loginMethod", payload.source);
          }
          resolve(res);
        })
        .catch((err) => {
          console.error("usersGet", err);
          reject(err);
        });
    });
  },
  appleUser({ commit, getters }, userID) {
    return new Promise((resolve, reject) => {
      api
        .appleUserGet(userID, getters.getUUID)
        .then((res) => {
          console.log("API appleUserGet", res.data);
          commit("setUser", res.data);
          commit("loginMethod", "apple");
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  newUser({ commit, getters }, payload) {
    // only used by facebook login (loginModal), others use magic login
    payload.uuid = getters.getUUID; // add uuid to login
    // console.log("DISPATCH createUser", payload);
    return new Promise((resolve, reject) => {
      api
        .userSourcesPost(payload)
        .then((res) => {
          console.log("API userSourcesPost", res.data);
          commit("setUser", res.data);
          commit("loginMethod", payload.source);
          resolve(res);
        })
        .catch((err) => {
          console.error("userSourcesPost", err);
          reject(err);
        });
    });
  },
  lineOAuthLogin({ commit }, payload) {
    vuexLineOAuth(payload.code, payload.redirect)
      .then((resp) => {
        console.log("OAuth success", resp);
        console.log("decode1", base64url.decode(resp.data.id_token));
        var payload = resp.data.id_token.split(".")[1];
        var decoded = base64url.decode(payload);
        var obj = JSON.parse(decoded);
        var lineUserData = {
          line_user_id: obj.sub,
          line_display_name: obj.name,
          line_profile_picture: obj.picture,
          created_at: new Date().toLocaleString(),
        };
        commit("setLineUser", lineUserData);
        this.dispatch("login", lineUserData.line_user_id); // ??
      })
      .catch((error) => console.log("ERR:" + error));
  },
  logout({ commit, state }) {
    if (!state.user) return alert("User not logged in");
    return new Promise((resolve, reject) => {
      api
        .logoutPatch(state.user.id, state.notificationToken)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
        .finally(() => commit("logout"));
    });
    // commit('logout') // logout on client, clears relevant objects from store
  },
  mobileLogin({ commit }, phoneNumber) {
    // console.log("login with phoneNumber:", phoneNumber);
    // commit("setUser", resp.data)
    commit("login");
    commit("loginMethod", "phone");
  },
  setProfilePic({ commit, state }, profilePic) {
    api.vuexUsersPatch(state.user.id, { profile_pic_url: profilePic });
    commit("setProfilePic", profilePic);
  },
  setRealName({ commit, state }, name) {
    api.vuexUsersPatch(state.user.id, { name: name });
    commit("setRealName", name);
  },
  setUUID({ state }) {
    if (state.user.uuid === state.uuid.uuid) return; // if no change
    api
      .vuexUsersPatch(state.user.id, { uuid: state.uuid.uuid }) // otherwise set
      .then((res) => console.log("setUUID userPatch success", res))
      .catch((err) => {
        console.error("setUUID usersPatch error", err);
      });
  },
  setNotificationToken({ commit, state }, token) {
    commit("setNotificationToken", token);
    if (!state.user) return; // can't save on user in db unless loggedin
    api.vuexUsersPatch(state.user.id, { notification_token: token });
  },
  setPhoneNumber({ commit, dispatch, state }, phoneNumber) {
    if (!state.user) return alert("Error: user not logged in"); // check logged in before hitting this
    return new Promise((resolve, reject) => {
      api
        .vuexUsersPatch(state.user.id, { phone_number: phoneNumber })
        .then((res) => {
          commit("setPhoneNumber", phoneNumber);
          dispatch("getRoles", state.user.id); // update roles
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  setLanguage({ state }, language) {
    api.vuexUsersPatch(state.user.id, { language: language });
  },
  setEmail({ commit, state }, email) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .usersPatch(state.user.id, { email: email })
        .then((res) => {
          commit("updateUser", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // update user field from user_info page
  patchUser(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .usersPatch(payload.id, payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // enterReferralCode({ commit, state }, referralCode) {
  //     if (!state.user) return
  //     return new Promise((resolve, reject) => {
  //         api.usersPatch(state.user.id, { referred_by: referralCode })
  //             .then(res => {
  //                 commit("updateUser", res.data)
  //                 resolve(res);
  //             })
  //             .catch(err => reject(err))
  //     });
  // },
  migrateUserMobile(_, data) {
    return new Promise((resolve, reject) => {
      api
        .usersPatchMigrate(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updateUserSettings({ state, commit }, data) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .usersPatchSettings(state.user.id, data)
        .then((res) => {
          commit("updateUser", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // user in /user_lookup by superusers to add data to user dataJSON
  updateUserData(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .usersPatchSettings(payload.userID, payload.data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  checkUser({ state, getters }) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .checkUserUUID(state.user.id, getters.getUUID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  checkPromoCode({ state }, code) {
    return new Promise((resolve, reject) => {
      api
        .promoCodeGet(code)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // rejectPromise(errMessage) {
  //   var err = { err: errMessage };
  //   return new Promise((_, reject) => reject(err));
  // },
  getNewShops(_, coords) {
    // var coords = getters.getUserLocationString;
    return new Promise((resolve, reject) => {
      api
        .newShopsGet(coords)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  checkDeliveryPrice({ state }) {
    return new Promise((resolve, reject) => {
      api
        .deliveryGetPrice()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // same as updateRoleData, below
  setRoleState({ state }, data) {
    // {state: "working"}
    return new Promise((resolve, reject) => {
      api
        .rolesPatch(data.id, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // same as setRoleState, above
  updateRoleData({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      api
        .rolesPatch(payload.id, payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  setWorkflowState({ state }, data) {
    // { state: "active" }
    return new Promise((resolve, reject) => {
      api
        .workflowsPatch(data.id, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  sendEmail(_, data) {
    return new Promise((resolve, reject) => {
      api
        .emailPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  sendLoginEmail(_, data) {
    return new Promise((resolve, reject) => {
      api
        .emailLoginPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // DEPRECATE
  fourDigitLoginStart({ commit }) {
    api
      .magicLoginPost()
      .then((res) => {
        console.log("magicLogin", res);
        commit("magicLogin", res.data);
      })
      .catch((err) => {
        console.error("fourDigitLogin err", err);
      });
  },
  loginStart({ commit, getters }, payload) {
    // source: "line", "sms"
    // payload = { source: "sms", phone_number: "+66..." }
    payload.uuid = getters.getUUID; // add uuid to login
    return new Promise((resolve, reject) => {
      api
        .magicLoginPost(payload)
        .then((res) => {
          console.log("magicLogin", res);
          commit("magicLogin", res.data);
          resolve();
        })
        .catch((err) => {
          console.error("fourDigitLogin err", err);
          reject(err);
        });
    });
  },
  // used by LoginLineModal
  fourDigitLoginSuccess({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      api
        .magicLoginGet(state.magicLogin.id)
        .then((res) => {
          console.log("magicLogin", res);
          commit("magicLogin", res.data);
          dispatch("login", res.data.source_user_id);
          resolve();
        })
        .catch((err) => {
          console.error("fourDigitLogin err", err);
          reject(err);
        });
    });
  },
  // check if four digit code for sms matches
  fourDigitLoginVerify({ commit, getters, dispatch, state }, code) {
    return new Promise((resolve, reject) => {
      api
        .magicLoginGetVerify(state.magicLogin.id, code)
        .then((res) => {
          console.log("magicLogin", res);
          // commit('magicLogin', res.data)
          commit("setUser", res.data); // sets user related objects
          commit("loginMethod", "sms");
          // set referral code if doesn't have on user, but has on device
          if (
            state.user &&
            !state.user.data.referred_by &&
            getters.getReferralCode
          ) {
            var data = {
              data: {
                referred_by: getters.getReferralCode,
                referred_at: new Date()
                  .toISOString()
                  .replace("T", " ")
                  .substr(0, 19), // golang time
              },
            };
            dispatch("updateUserSettings", data);
          }
          // dispatch("login", res.data.source_user_id)
          resolve();
        })
        .catch((err) => {
          console.error("fourDigitLogin err", err);
          reject(err);
        });
    });
  },
  // if sms fails and user tries to resend just send via push message
  fourDigitLoginResend({ state }) {
    return new Promise((resolve, reject) => {
      api
        .magicLoginGetResend(state.magicLogin.id, state.notificationToken)
        .then((res) => {
          console.log("magicLoginGetResend", res);
          resolve(res);
        })
        .catch((err) => {
          console.error("fourDigitLoginGetResend err", err);
          reject(err);
        });
    });
  },
  createBusiness({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .businessesPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updateBusiness({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .businessesPatch(data.id, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updateBusinessActive(_, data) {
    return new Promise((resolve, reject) => {
      api
        .businessesPatchActive(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // uses location of user which may not always be safe
  // for on demand pickups it's okay
  createTransactionNearby({ getters }, data) {
    var coords = getters.getUserLocationString;
    return new Promise((resolve, reject) => {
      api
        .transactionsPostNearby(data, coords)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // /fraud/promo_cancellations?user_id=abc123
  checkFraudPromoCancellations({ state }) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .fraudPromoCancellations(state.user.id)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  testDebounce({ commit, state }) {
    // if (debounce(commit, state, "testDebounce", 10)) return console.log("debounce TRUE");
    // return console.log("debounce FALSE")
    return new Promise((resolve, reject) => {
      if (debounce(commit, state, "testDebounce", 10)) reject("debounce");
      else resolve("okay");
    });
  },
  createStripeCharge({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .stripePost("charge", data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  createTransaction({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      if (debounce(commit, state, "createTransaction", 5))
        return reject("debounce");
      api
        .transactionsPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  createTransactionNoDebounce(ctx, data) {
    return new Promise((resolve, reject) => {
      api
        .transactionsPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  triggerMoreSiilors({ commit }, transactionID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsTriggerMoreSiilors(transactionID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  triggerInactiveSiilors({ commit }, transactionID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsTriggerInactiveSiilors(transactionID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  saveDevice({ state }, timestamp) {
    state.device.client_time = timestamp;
    var payload = { data: JSON.stringify(state.device) };
    if (state.user) payload.user_id = state.user.id;
    api
      .devicesPost(state.uuid.uuid, payload)
      // .then(res => console.log("API devicesPost", res.data))
      .catch((err) => console.error("API devicesPost", err));
  },
  createTukExpressFromPastOrder(_, commerceOrderID) {
    const data = {
      commerce_order_id: commerceOrderID,
    };
    return new Promise((resolve, reject) => {
      api
        .createTukExpressFromPastOrder(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  createNewShop(_, data) {
    return new Promise((resolve, reject) => {
      api
        .createShopPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBusinessAndWorkflowsBreakCache(_, businessID) {
    return new Promise((resolve, reject) => {
      api
        .getBusinessAndWorkflows(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getAndSelectBusiness({ commit }, businessID) {
    // used when trying to access business not in your area
    // or just updating business+workflows, it gets both
    return new Promise((resolve, reject) => {
      api
        .businessesGetSingle(businessID)
        .then((res) => {
          commit("cacheBusiness", res.data); // caches  in state.businesses
          commit("selectBusiness", businessID); // sets from cache
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getBusinessAndWorkflow(_, payload) {
    // used by ChangeCommerceAgent.vue
    return new Promise((resolve, reject) => {
      api
        .businessesGetWorkflows(payload.business_id, payload.workflow_type)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getAgentPickupStop(_, businessID) {
    // for now agent pickup stop is simple the business location and name
    return new Promise((resolve, reject) => {
      api
        .businessesGetSingle(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDeliveryTransactionsByWorkflow({ commit, state }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByDeliveryWorkflowID(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getTransactionByID(_, transactionID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByID(transactionID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getTransactionsByWorkflow({ commit, state }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByWorkflowID(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getTransactionsByWorkflowType({ commit, state }, data) {
    // payload contains fields type and offset
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByWorkflowType(data.type, data.offset, data.status)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDriverStats({ commit }, driverID) {
    return new Promise((resolve, reject) => {
      api
        .getDriverStats(driverID)
        .then((res) => {
          commit("setDriverStats", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getRecentDriverRemitTransactions(_, driverID) {
    return new Promise((resolve, reject) => {
      api
        .getRecentDriverRemitTransactions(driverID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // should probably be called getTransactionsForDriver...
  getTransactionsForWorker({ commit, state }, payload) {
    var workflowID = payload.workflowID;
    var force = payload.force;
    if (!state.user) return;
    var userID = state.user.id;
    if (state.isWorking && state.workingState === "Dispatcher")
      userID = "dispatcher";
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByWorkflowIDAndUserID(workflowID, userID, force) // api.transactionsGetByWorkflowID(workflowID)
        .then((res) => {
          commit("setTransactionsForWorker", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getOngoingTransactionsForWorker({ commit, state }) {
    if (!state.user) return;
    var userID = state.user.id;
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByWorkerID(userID)
        .then((res) => {
          commit("setOngoingTransactionsForWorker", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getOngoingTransactionsForFleetDispatcher({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetOngoingFleet(workflowID)
        .then((res) => {
          commit("setOngoingDispatcherTransactions", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getOngoingTransactionsForCommerceAgent({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetOngoingByWorkflowID(workflowID)
        .then((res) => {
          commit("setOngoingCommerceAgentTransactions", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getPastTransactionsForCommerceAgent({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetPastByWorkflowID(workflowID)
        .then((res) => {
          commit("setPastCommerceAgentTransactions", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getOngoingTransactionsForLogisticsAgent({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetOngoingLogistics(workflowID)
        .then((res) => {
          commit("setOngoingLogisticsAgentTransactions", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getPastTransactionsForLogisticsAgent({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetPastLogistics(workflowID)
        .then((res) => {
          commit("setPastLogisticsAgentTransactions", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getLogisticsOrder({ commit }, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetLogisticsOrder(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRideOrder({ commit }, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetRideOrder(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceOrder(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetCommerceOrder(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceOrderForAgent(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetCommerceOrderForAgent(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getPartialCommerceOrderForAgent(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetPartialCommerceOrderForAgent(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceDelivery(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetCommerceDelivery(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  isShopOpen(_, handle) {
    return new Promise((resolve, reject) => {
      api
        .isShopOpen(handle)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  isShopOpenByID(_, businessID) {
    return new Promise((resolve, reject) => {
      api
        .isShopOpenByID(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  incrementCommerceOrder(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .incrementCommerceOrder(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  incrementCallShopCounter(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .incrementCallShopCounter(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  assignDriverToCommerceOrder(_, { transactionID, driverPhoneNumber }) {
    return new Promise((resolve, reject) => {
      api
        .assignDriverToCommerceOrder(transactionID, driverPhoneNumber)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  changeCommerceOrderToAutoconfirm(_, transactionID) {
    return new Promise((resolve, reject) => {
      api
        .changeCommerceOrderToAutoconfirm(transactionID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getTransactionsForCustomer({ commit, state }) {
    if (!state.user) return;
    var customerID = state.user.id;
    return new Promise((resolve, reject) => {
      api
        .transactionsGetByUserID(customerID)
        .then((res) => {
          commit("setTransactionsForCustomer", res.data);
          commit("setMapState");
          console.log("API getTransactionsForCustomer", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getRecentTransactionsForCustomer({ commit, state }) {
    if (!state.user) return;
    var customerID = state.user.id;
    return new Promise((resolve, reject) => {
      api
        .transactionsGetRecentByUserID(customerID)
        .then((res) => {
          commit("setRecentTransactionsForCustomer", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getOngoingTransactionsForCustomer({ commit, state }) {
    if (!state.user) return;
    var customerID = state.user.id;
    return new Promise((resolve, reject) => {
      api
        .transactionsGetOngoingByUserID(customerID)
        .then((res) => {
          commit("setOngoingTransactionsForCustomer", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getRelevantTransactionsForUser(_, payload) {
    var userID = payload.userID;
    var offset = payload.offset;
    return new Promise((resolve, reject) => {
      api
        .transactionsGetRelevantToUserID(userID, offset)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getTransactionStatsForUser(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetStatsForUserID(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getTransactionTopShopsForUser(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsGetTopShopsForUserID(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  patchTransaction({ getters }, payload) {
    if (!payload.data.data) payload.data.data = {};
    payload.data.data.patch_coords = getters.getUserLatLon;
    return new Promise((resolve, reject) => {
      api
        .transactionsPatch(payload.transactionID, payload.data)
        .then((res) => resolve(res))
        .catch((err) => {
          console.error("API patchTransactions", err);
          reject(err);
        });
    });
  },
  replicateTransaction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .transactionsReplicate(payload.transactionID, payload.date)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  readMessage(_, messageID) {
    return new Promise((resolve, reject) => {
      api
        .userMessagesPatch(messageID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteMessage(_, messageID) {
    return new Promise((resolve, reject) => {
      api
        .userMessagesDelete(messageID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRecommendationsForYouEat({ commit, getters }) {
    return new Promise((resolve, reject) => {
      api
        .recommendationsGet("foryou", "eat", getters.getUserID)
        .then((res) => {
          commit("setForYouEat", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getDriverRemitTransactionForDate({ state }, payload) {
    var userID = state.user.id;
    if (payload.driverID) userID = payload.driverID; // used in DriverWalletView
    return new Promise((resolve, reject) => {
      api
        .getDriverRemitTransactionForDate(userID, payload.date)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDriverHistory({ state }, driverID) {
    var userID = state.user.id;
    if (driverID) userID = driverID; // used in DriverWalletView
    return new Promise((resolve, reject) => {
      api
        .analyticsGetDriverHistory(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDriverWalletData({ state }, driverID) {
    var userID = state.user.id;
    if (driverID) userID = driverID; // used in DriverWalletView
    return new Promise((resolve, reject) => {
      api
        .analyticsGetDriverWalletData(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDispatcherHistory(_, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .analyticsGetDispatcherHistory(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getClosestDeliveryDrivers(_, transactionID) {
    return new Promise((resolve, reject) => {
      api
        .getClosestDeliveryDrivers(transactionID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRideCount({ state, commit }) {
    if (!state.user) return; // skip if user not set
    return new Promise((resolve, reject) => {
      api
        .analyticsGetRideCount(state.user.id)
        .then((res) => {
          console.log("getRideCount", res.data);
          commit("setRideCount", res.data); // state.rideCount = res.data
          resolve(res);
        })
        .catch((err) => {
          console.error("getRideCount", err);
          reject(err);
        });
    });
  },
  getCommerceOrderCount(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .analyticsGetCommerceOrderCount(payload.workflowID, payload.userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getLalamoveQuote(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .lalamoveGetQuote(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  addTipToDelivery(_, data) {
    return new Promise((resolve, reject) => {
      api
        .addTipToDelivery(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  addTukpayToDelivery(_, data) {
    return new Promise((resolve, reject) => {
      api
        .addTukpayToDelivery(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  addTukDiscountToOrder(_, data) {
    return new Promise((resolve, reject) => {
      api
        .addTukDiscountToOrder(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  addServiceFeeAdjustmentToOrder(_, data) {
    return new Promise((resolve, reject) => {
      api
        .addServiceFeeAdjustmentToOrder(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  cancelLalamoveOrder(_, data) {
    return new Promise((resolve, reject) => {
      api
        .cancelLalamoveOrder(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  retryLalamoveOrder(_, data) {
    return new Promise((resolve, reject) => {
      api
        .retryLalamoveOrder(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  checkVersion({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .versionGet()
        .then((res) => {
          if (res.data && res.data.server_time) {
            commit("setServerTimeFetch", {
              serverTime: new Date(res.data.server_time).getTime(),
              clientTime: Date.now(),
            });
          }
          resolve(res.data.version || res.data);
        })
        .catch((err) => reject(err));
    });
  },
  getBusinessesByType(_, businessType) {
    return new Promise((resolve, reject) => {
      api
        .businessesGetByTypeForSuperuser(businessType)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBusinessesNearby({ commit, getters }) {
    var coords = getters.getUserLocationString;
    if (!coords) return; // skip if don't know user location yet
    return new Promise((resolve, reject) => {
      api
        .businessesGet(coords)
        .then((res) => {
          commit("setBusinesses", res.data);
          console.log("API getBusinesses", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getEateriesNearby({ commit, getters }) {
    var coords = getters.getUserLocationString; // will return null if location unknown
    return new Promise((resolve, reject) => {
      api
        .eateriesGet(coords)
        .then((res) => {
          commit("setEateries", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getMartsNearby({ commit, getters }) {
    var coords = getters.getUserLocationString; // will return null if location unknown
    return new Promise((resolve, reject) => {
      api
        .martsGet(coords)
        .then((res) => {
          commit("setMarts", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getTransportNearby({ commit, getters }) {
    var coords = getters.getUserLocationString; // will return null if location unknown
    return new Promise((resolve, reject) => {
      api
        .transportGet(coords)
        .then((res) => {
          commit("setTransport", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getUserStops({ commit, getters, state }) {
    if (!state.user) return;
    var userID = state.user.id;
    var coords = getters.getUserLocationString; // will return null if location unknown
    return new Promise((resolve, reject) => {
      api
        .userStopsGet(userID, coords)
        .then((res) => {
          commit("setUserStops", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  createWorkflow({ commit }, data) {
    // commit("logAction", "createWorkflow")
    // console.log("DISPATCH createWorkflow", data);
    return new Promise((resolve, reject) => {
      api
        .workflowsPost(data)
        .then((resp) => {
          console.log("API createWorkflow", resp.data);
          // dispatch("getWorkflows") // update list of workflows
          resolve();
        })
        .catch((err) => {
          console.error("API createWorkflow -", err.response);
          // alert("createWorkflow API error:", err);
          reject(err);
        });
    });
  },
  updateWorkflow(_, payload) {
    console.log("updateWorkflow", payload);
    return new Promise((resolve, reject) => {
      api
        .workflowsPatch(payload.id, payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updateWorkflowData(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .workflowsPatchData(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  saveGeometryOnWorkflow(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .workflowsPatchGeometry(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // gets roles for this user and sets in store
  getRoles({ commit }, userID) {
    return new Promise((resolve, reject) => {
      api
        .rolesGet(userID)
        .then((res) => {
          commit("setRoles", res.data);
          resolve(res);
        })
        .catch((err) => {
          console.error("API getRoles", err);
          reject(err);
        });
    });
  },
  getDevicesByUserID(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .devicesGetByUserID(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getPastAddresses(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .getPastAddressesByUserID(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  // get role for any user, don't set in store
  getRolesByUserID(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .rolesGet(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRolesByBusiness(_, businessID) {
    return new Promise((resolve, reject) => {
      api
        .rolesGetByBusinessID(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRolesByWorkflow({ commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .rolesGetByWorkflowID(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRolesByWorkflowIDAndRoleName({ commit }, { workflowID, roleName }) {
    return new Promise((resolve, reject) => {
      api
        .rolesGetByWorkflowIDAndRoleName(workflowID, roleName)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  changeDriverRole({}, data) {
    return new Promise((resolve, reject) => {
      api
        .rolesPatch(data.id, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  createRole({ commit, state }, data) {
    var locale = state.i18n.locale; // could check that state.i18n not null
    console.log("DISPATCH createRole", data);
    return new Promise((resolve, reject) => {
      api
        .rolesPost(locale, data)
        .then((res) => {
          console.log("API createRole", res.data);
          resolve(res);
        })
        .catch((err) => {
          console.error("API createRole", err.response);
          reject(err);
        });
    });
  },
  deleteRole({ commit }, roleID) {
    // console.log("DISPATCH deleteRole", roleID);
    return new Promise((resolve, reject) => {
      api
        .rolesDelete(roleID)
        .then((res) => {
          console.log("API deleteRole", res.data);
          resolve();
        })
        .catch((err) => {
          console.error("API deleteRole", err.response);
          reject(err);
        });
    });
  },
  deleteUser({ commit }, ID) {
    return new Promise((resolve, reject) => {
      api
        .usersDelete(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteBusiness({ commit }, ID) {
    return new Promise((resolve, reject) => {
      api
        .businessesDelete(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  replicateBusiness(_, businessID) {
    return new Promise((resolve, reject) => {
      api
        .businessesReplicate(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  replicateWorkflows(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .workflowsReplicate(payload.old, payload.new)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  overwriteCommerceBlobs(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .overwriteCommerceBlobs(payload.from, payload.to)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getPausedShops() {
    return new Promise((resolve, reject) => {
      api
        .getPausedShops()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getActiveBasketsCount() {
    return new Promise((resolve, reject) => {
      api
        .getActiveBasketsCount()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceOrderStats() {
    return new Promise((resolve, reject) => {
      api
        .getCommerceOrderStats()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  forceChangeTransactionState(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .forceChangeTransactionState(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceOrderViewingHistory(_, transactionID) {
    return new Promise((resolve, reject) => {
      api
        .getCommerceOrderViewingHistory(transactionID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceAgentsInfo(_, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .getCommerceAgentsInfo(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getActiveDeliveryDrivers() {
    return new Promise((resolve, reject) => {
      api
        .getActiveDeliveryDrivers()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDeliveryFleetStats() {
    return new Promise((resolve, reject) => {
      api
        .deliveryFleetStats()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSuperuserStats() {
    return new Promise((resolve, reject) => {
      api
        .superuserStats()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceStats(_, businessID) {
    return new Promise((resolve, reject) => {
      api
        .commerceStats(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceOrderHistoryCountsForBusiness(_, businessID) {
    return new Promise((resolve, reject) => {
      api
        .commerceOrderHistoryCountsForBusiness(businessID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceOrderHistoryForPeriod(_, data) {
    return new Promise((resolve, reject) => {
      api
        .commerceOrderHistoryForPeriod(data.business_id, data.period)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteTransaction(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsDelete(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  undeleteTransaction(_, ID) {
    return new Promise((resolve, reject) => {
      api
        .transactionsUndelete(ID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getShopPhotos({ commit }, businessID) {
    return new Promise((resolve, reject) => {
      tukPhotos(businessID)
        .then((res) => {
          commit("setPhotosOnBusiness", res.data); // sets photos on selectedBusiness
          console.log("API getShopPhotos", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getCommerceDeliveryWorkflows(_, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .workflowsGetCommerceDelivery(workflowID)
        .then((res) => {
          // commit("setWorkflowsOnBusiness", res.data); // sets workflows on selectedBusiness
          // console.log("API getWorkflows", res.data);
          resolve(res);
        })
        .catch((err) => {
          // commit("setWorkflowsOnBusiness", []); // prob better not to clear
          reject(err);
        });
    });
  },
  getWorkflows({ commit }, businessID) {
    return new Promise((resolve, reject) => {
      api
        .workflowsGet(businessID)
        .then((res) => {
          commit("setWorkflowsOnBusiness", res.data); // sets workflows on selectedBusiness
          console.log("API getWorkflows", res.data);
          resolve(res);
        })
        .catch((err) => {
          commit("setWorkflowsOnBusiness", []); // prob better not to clear
          reject(err);
        });
    });
  },
  // should deprecate this ASAP
  getWorkflowsAll({ commit, state, getters }) {
    if (state.timestamps.getWorkflowsAll) {
      var diff =
        (new Date() - new Date(state.timestamps.getWorkflowsAll)) / 1000;
      if (diff < 19) return; // don't let this run often
    }
    var coords = getters.getUserLocationString;
    if (!coords) return; // skip if don't know user location yet
    commit("setTimestamp", "getWorkflowsAll");
    return new Promise((resolve, reject) => {
      api
        .workflowsGetAll(coords)
        .then((res) => {
          commit("setWorkflows", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getWorkflowsByType({ commit }, workflowType) {
    // not using this anymore, changed to getWorkflowsAll
    return new Promise((resolve, reject) => {
      api
        .workflowsGetByType(workflowType)
        .then((res) => {
          commit("setWorkflows", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  getWorkflowByID({ commit }, id) {
    // should debounce here (e.g. 1 second)
    // console.log("DISPATCH getWorkflowByID");
    return new Promise((resolve, reject) => {
      api
        .workflowsGetByID(id)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  getMagicLogins() {
    return new Promise((resolve, reject) => {
      api
        .magicLoginsGet()
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  logDriverCoords({ state, getters, dispatch }, data) {
    if (!getters.isDriver) return;
    if (!getters.driverHasActiveJobs) return;
    // if (!state.workerTransactions) return false; // checked by above
    var arr = ["initiated", "alighted", "scheduled", "cancelled_by_passenger"]; // not active states
    var transactions = state.workerTransactions.filter(
      (t) => !arr.includes(t.state)
    );

    var obj = {
      lat: data.lat,
      lon: data.lon,
      accuracy: Math.round(data.accuracy), // meters
      distance: data.distance, // distance from previous position
      transactions: transactions.map((t) => {
        return {
          id: t.id,
          state: t.state,
        };
      }),
    };
    dispatch("logEvent", { event: "driver_location", data: obj });
  },
  saveUserState({ state, dispatch, commit }, data) {
    if (state.timestamps.postUserState) {
      var diff = (new Date() - new Date(state.timestamps.postUserState)) / 1000;
      if (diff < 19) return; // only post new user state every 10 seconds
    }
    commit("setTimestamp", "postUserState");
    commit("setUserState", data);
    dispatch("logDriverCoords", data); // if driver and has ongoing transaction
    return new Promise((resolve, reject) => {
      api
        .userStatesPost(data)
        .then((res) => resolve(res))
        .catch((err) => {
          console.error("API saveUserState", err);
          reject(err);
        });
    });
  },
  deleteUserAddress(_, addressID) {
    return new Promise((resolve, reject) => {
      api
        .userAddressesDelete(addressID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  editUserAddress(_, data) {
    return new Promise((resolve, reject) => {
      api
        .userAddressesPatch(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  saveUserAddress(_, data) {
    return new Promise((resolve, reject) => {
      api
        .userAddressesPost(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getUserAddress({ commit }, phoneNumber) {
    return new Promise((resolve, reject) => {
      api
        .userAddressesGetDelivery(phoneNumber)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getUserAddresses({ commit, state }) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .userAddressesGet(state.user.id)
        .then((res) => {
          commit("setUserAddresses", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getAddressesByUserID(_, userID) {
    return new Promise((resolve, reject) => {
      api
        .userAddressesGet(userID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getLogisticsFleet({ commit }, businessID) {
    return new Promise((resolve, reject) => {
      api
        .logisticsFleetGet(businessID)
        .then((res) => {
          commit("setLogisticsFleet", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  trackDrivers({ state, commit }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .workerStatesGetByWorkflowID(workflowID) // gets userStates for workflow
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  trackSiilors({ state, commit }) {
    return new Promise((resolve, reject) => {
      api
        .workerStatesGetByWorkflowType("Sii Lor") // gets siilor driver userStates
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  trackNearby({ getters }, id) {
    var coords = getters.getUserLocationString;
    return new Promise((resolve, reject) => {
      api
        .workerStatesGetByWorkflowIDNearby(id, coords) // gets nearby driver userStates
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  // getValidation() {
  //     return new Promise((resolve, reject) => {
  //         api.validationGet().then(res => resolve(res)).catch(err => reject(err))
  //     });
  // },
  logCustom({ getters }, payload) {
    payload.user_id = getters.getUserID;
    payload.uuid = getters.getUUID;
    api
      .logsPost(payload)
      // .then(res => console.log("logEvent", res.data))
      .catch((err) => console.error("logEvent", err));
  },
  logEvent({ getters }, data) {
    var payload = {
      log_type: "client_event",
      data: JSON.stringify(data),
      user_id: getters.getUserID,
      uuid: getters.getUUID,
    };
    api
      .logsPost(payload)
      // .then(res => console.log("logEvent", res.data))
      .catch((err) => console.error("logEvent", err));
  },
  logError({ getters }, data) {
    var payload = {
      log_type: "client_error",
      data: JSON.stringify(data),
      user_id: getters.getUserID,
      uuid: getters.getUUID,
    };
    api
      .logsPost(payload)
      .then((res) => console.log("reportError", res.data))
      .catch((err) => console.error("reportError", err));
  },
  createDriverRemit(_, date) {
    return new Promise((resolve, reject) => {
      api
        .createDriverRemit(date)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  readyDriverRemit(_, date) {
    return new Promise((resolve, reject) => {
      api
        .readyDriverRemit(date)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  autocompleteUsers(_, text) {
    return new Promise((resolve, reject) => {
      api
        .userAutocomplete(text)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  autocompleteBusinessWorkflows(_, workflowType) {
    return new Promise((resolve, reject) => {
      api
        .businessWorkflowsAutocomplete(workflowType)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  autocompleteSearch(_, text) {
    return new Promise((resolve, reject) => {
      api
        .searchAutocomplete(text)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  autocompleteBusinesses(_, text) {
    return new Promise((resolve, reject) => {
      api
        .businessAutocomplete(text)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  searchMenuItems(_, text) {
    return new Promise((resolve, reject) => {
      api
        .searchMenuItems(text)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  autocompleteDrivers(_, text) {
    return new Promise((resolve, reject) => {
      api
        .driverAutocomplete(text)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getDriversForWorkflow(_, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .driversByWorkflowGet(workflowID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  autocompleteDriverWorkflows({ state }, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .driverWorkflowsAutocomplete(workflowID)
        .then((res) => {
          state.workflowDrivers = res.data; // should use commit, not edit state directly
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  autocompleteDeliveryDrivers(_, workflowID) {
    return new Promise((resolve, reject) => {
      api
        .deliveryWorkflowsAutocomplete(workflowID)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  getRecentlyFailedCustomerCommerceOrders({ state }) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .getRecentlyFailedCustomerCommerceOrders(state.user.id)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getMessagesForUser({ commit, state }) {
    if (!state.user) return;
    return new Promise((resolve, reject) => {
      api
        .userMessagesGet(state.user.id)
        .then((res) => {
          commit("setMessages", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  sendMessageToUser(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .userMessagePost(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  sendMessageToWorkflow(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .workflowMessagePost(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  sendBroadcastMessage(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .broadcastMessagePost(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  createShortLink({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .shortLinkPost(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getShortLink({ commit }, shortID) {
    return new Promise((resolve, reject) => {
      api
        .shortLinkGet(shortID)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getRecentShortLinks({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .shortLinkGet("recent") // hacking the normal GET endpoint
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  patchShortLink({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .shortLinkPatch(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  killLongRunningQueries() {
    return new Promise((resolve, reject) => {
      api
        .killLongRunningQueries()
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  createCommerceInvoice(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .commerceInvoicesPost(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getCommerceInvoices(_, payload) {
    return new Promise((resolve, reject) => {
      api
        .commerceInvoicesGet(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
